import EsgGreenhouseFooter from './EsgGreenhouseFooter';

export default EsgGreenhouseFooter;
